import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home } from "lucide-react";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";
import { SEO } from "../components/seo/SEO";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title={`${t("notFound.title", "Seite nicht gefunden")} | Equna`}
        description={t("notFound.description", "Diese Seite existiert nicht.")}
        robots="noindex,follow"
      />
      <LegalPageLayout title={t("notFound.heading", "404 – Seite nicht gefunden")}>
        <div className="space-y-6">
          <p className="text-slate-600 leading-relaxed">
            {t(
              "notFound.body",
              "Die aufgerufene Seite gibt es nicht (mehr). Vielleicht hat sich ein Tippfehler in die Adresse geschlichen oder der Link ist veraltet."
            )}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold text-white bg-[#237CCA] rounded-full hover:bg-[#1f6fb5] transition-colors"
            >
              <Home className="w-4 h-4" />
              {t("notFound.cta", "Zur Startseite")}
            </Link>
            <Link
              to="/support"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors"
            >
              {t("notFound.support", "Support kontaktieren")}
            </Link>
          </div>
        </div>
      </LegalPageLayout>
    </>
  );
}
